import React from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import ImageDocumentPreviewBody from "./widget/ImageDocumentPreviewBody";
import { Col } from "react-bootstrap";
import ImageDocumentPreviewActions from "./widget/ImageDocumentPreviewActions";
import Div from "../../../widget/common/ui/Div";

const ImageDocumentPreviewContent = (props: {
  type?: number | undefined;
  isModal?: boolean | false;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const isModal: boolean = props.isModal ?? false;

  return (
    <>
      {type === 3 ? (
        <Col xs={12} xl={10} className="h-100 mx-auto">
          <Div className="py-5">
            <ImageDocumentPreviewBody isModal={isModal} />
          </Div>
          <Div className="d-center">
            <ImageDocumentPreviewActions isModal={true} />
          </Div>
        </Col>
      ) : (
        <ImageDocumentPreviewBody />
      )}
    </>
  );
};

export default ImageDocumentPreviewContent;
